import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {
    display: {
      xs: 'grid',
      md: 'flex',
    },
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    alignItems: 'center',
    minHeight: '55px',
    padding: '1rem',
    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
    gap: '.5rem 1rem',
    cursor: 'pointer',
    '&:hover': {
      background: (theme) => theme.palette.shade?.[100],
    },
    gridTemplateColumns: 'auto 1fr auto',
  },
  Icon: {
    height: '2rem',
    width: '2rem',
    gridRow: 'span 2',
  },
  coloredIcon: {
    height: '2rem',
    width: '2rem',
    color: (theme) => theme.palette.primary.main,
    gridRow: 'span 2',
  },
  organizationIcon: {
    height: '1.5rem',
    width: '1.5rem',
    gridRow: 'span 2',
  },
  templateName: {
    flex: 1,
    gridColumn: '2',
  },
  templateDate: {
    gridColumn: '2',
  },
});

export default useSx;
